import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 220px;
  /* max-width: 420px; */
`;

export const IconWrapper = styled.div`
  position: absolute;
  left: 14px;
  display: flex;
  pointer-events: none;
`;

export const Input = styled.input`
  width: 100%;
  height: 42px;

  padding: 0 16px 0 44px;

  background-color: ${colors.surfaceContainer};
  border: none;
  border-radius: ${radius.full};

  color: ${colors.onSurface};
  font-size: 13px;
  font-family: inherit;

  &::placeholder {
    color: ${colors.onSurfaceVariant};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 1px ${colors.primary}50;
  }
`;
